import type { SVGProps } from "react";

/**
 * InsuraMentor combines InsuraBot's rounded screen and pill eyes with a
 * folded M body. The shared silhouette stays readable at navigation sizes
 * and inherits the surrounding theme color without gradients or SVG IDs.
 */
export function MentorMark({
  size = 24,
  strokeWidth = 2,
  className,
  ...props
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
} & SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* InsuraBot's screen crown and signature vertical eyes. */}
      <path d="M5 11V5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5V11" />
      <path d="M9.5 7v1.5m5-1.5v1.5" />
      {/* The screen flows into broad M shoulders and folded feet. */}
      <g fill="currentColor" stroke="none">
        <path d="M3 20V10.75a.75.75 0 0 1 1.2-.6L12 16l7.8-5.85a.75.75 0 0 1 1.2.6V20l-3.5 2v-6L12 20l-5.5-4v6Z" />
        <path d="m3 20 3.5 2H3Zm18 0-3.5 2H21Z" opacity="0.4" />
      </g>
    </svg>
  );
}
